import React from 'react';

const MedicationSelectionStep = ({ question, value, onAnswer, onNext }) => {
  const handleSelect = (optionValue) => {
    onAnswer(optionValue);
    // Auto-advance after selection
    setTimeout(() => {
      onNext();
    }, 200);
  };

  return (
    <div data-testid={`step-${question.id}`}>
      {/* Question */}
      <h2 className="text-2xl md:text-3xl font-semibold text-center text-gray-900 mb-2">
        {question.question}
      </h2>

      {/* Subtitle */}
      <p className="text-center text-gray-500 mb-8">
        This will help your provider determine the best treatment option for you
      </p>

      {/* Medication Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {question.options.map((option, index) => (
          <button
            key={index}
            onClick={() => handleSelect(option.value)}
            className={`relative p-6 rounded-2xl text-left transition-all border-2 ${
              value === option.value
                ? 'border-[#2d8a5f] bg-[#f0faf4]'
                : 'border-gray-200 hover:border-[#2d8a5f] bg-white hover:bg-gray-50'
            }`}
            data-testid={`medication-${option.value}`}
          >
            {/* Selection indicator */}
            <div className={`absolute top-4 right-4 w-6 h-6 rounded-full border-2 flex items-center justify-center ${
              value === option.value
                ? 'border-[#2d8a5f] bg-[#2d8a5f]'
                : 'border-gray-300'
            }`}>
              {value === option.value && (
                <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
              )}
            </div>

            {/* Icon */}
            <div className="w-12 h-12 bg-[#e8f5ee] rounded-xl flex items-center justify-center mb-4">
              <svg className="w-6 h-6 text-[#2d8a5f]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19.428 15.428a2 2 0 00-1.022-.547l-2.387-.477a6 6 0 00-3.86.517l-.318.158a6 6 0 01-3.86.517L6.05 15.21a2 2 0 00-1.806.547M8 4h8l-1 1v5.172a2 2 0 00.586 1.414l5 5c1.26 1.26.367 3.414-1.415 3.414H4.828c-1.782 0-2.674-2.154-1.414-3.414l5-5A2 2 0 009 10.172V5L8 4z" />
              </svg>
            </div>

            {/* Label */}
            <h3 className="text-xl font-semibold text-gray-900 mb-1">
              {option.label}
            </h3>

            {/* Description */}
            {option.description && (
              <p className="text-sm text-gray-500">
                Brand names: {option.description}
              </p>
            )}
          </button>
        ))}
      </div>

      {/* Info Box */}
      <div className="mt-6 bg-blue-50 rounded-xl p-4">
        <div className="flex items-start gap-3">
          <svg className="w-5 h-5 text-blue-500 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
          </svg>
          <p className="text-sm text-blue-700">
            Both medications are effective for weight loss. Your provider will review your selection and may recommend adjustments based on your medical history.
          </p>
        </div>
      </div>
    </div>
  );
};

export default MedicationSelectionStep;
